export const tags = [
    "ai-chat",
    "jnct-ai-drag-and-drop-modal",
    "diagnostic-ai-chat",
    "jnct-ai-report",
] as const;
